const snakeCase = (str) =>
  str
    .replace(/([A-Z])/g, (match) => `_${match.toLowerCase()}`)
    .replace(/^_/, "");

export const objectToSnakeCase = (obj) =>
  Object.fromEntries(Object.entries(obj).map(([k, v]) => [snakeCase(k), v]));
